// extracted by mini-css-extract-plugin
export default {"item":"styles_item__gk2V0","header_item":"styles_header_item__j6WVr","content_item":"styles_content_item__kwP4i","delete_box":"styles_delete_box__p779K"};